<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="pskov-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-close-on-backdrop
    no-header
    shadow
    :width="sidebarWidth"
    @shown="getData"
    @hidden="resetSidebarData"
    ref="pskovPriceSidebar">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление прайса Псков</h2>
          <h2 v-else class="my-4">Редактирование прайса Псков</h2>
            <b-row>
              <b-col>
                <b-form-group
                  label="Месяц начала действия прайса"
                  label-for="dateStart"
                  label-class="mf-label"
                  class="my-3">
                  <a-month-picker
                    class="mr-3"
                    size="large"
                    v-model="dateStart"
                    format="MM/YYYY"
                    :disabled="disabled"
                    placeholder="Дата"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="8">
                <b-table
                  id="data_table"
                  ref="packages"
                  hover
                  class="text-center"
                  tbody-tr-class="td-centered"
                  :fields="fields"
                  :items="modelPackages">
                  <template v-slot:cell(packageName)="data">
                    <b>{{ data.item.packageName }}</b>
                  </template>
                  <template v-slot:cell(rangeDefault)="data">
                    <b-form-group
                      v-if="data.item.packageName === '10 пакетов'"
                      :invalid-feedback="getError('10 пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefault1-input"
                        name="10 пакетов"
                        v-validate="priceValidation"
                        data-vv-as="10 пакетов"
                        class="text-right"
                        v-model="modelPackages[0].clientPrice"
                        :disabled="disabled"
                        :state="validateState('10 пакетов')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '20 пакетов'"
                      :invalid-feedback="getError('20 пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefault2-input"
                        name="20 пакетов"
                        v-validate="priceValidation"
                        data-vv-as="20 пакетов"
                        class="text-right"
                        v-model="modelPackages[1].clientPrice"
                        :disabled="disabled"
                        :state="validateState('20 пакетов')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '50 пакетов'"
                      :invalid-feedback="getError('50 пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefault3-input"
                        name="50 пакетов"
                        v-validate="priceValidation"
                        data-vv-as="50 пакетов"
                        class="text-right"
                        v-model="modelPackages[2].clientPrice"
                        :disabled="disabled"
                        :state="validateState('50 пакетов')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '100 пакетов'"
                      :invalid-feedback="getError('100 пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefault4-input"
                        name="100 пакетов"
                        v-validate="priceValidation"
                        data-vv-as="100 пакетов"
                        class="text-right"
                        v-model="modelPackages[3].clientPrice"
                        :disabled="disabled"
                        :state="validateState('100 пакетов')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200 пакетов'"
                      :invalid-feedback="getError('200 пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefault5-input"
                        name="200 пакетов"
                        v-validate="priceValidation"
                        data-vv-as="200 пакетов"
                        class="text-right"
                        v-model="modelPackages[4].clientPrice"
                        :disabled="disabled"
                        :state="validateState('200 пакетов')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefault6-input"
                        name="200+"
                        v-validate="priceValidation"
                        data-vv-as="200+"
                        class="text-right"
                        v-model="modelPackages[5].clientPrice"
                        :disabled="disabled"
                        :state="validateState('200+')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                  <template v-slot:cell(rangeRecalc)="data">
                    <b-form-group
                      v-if="data.item.packageName === '10 пакетов'"
                      :invalid-feedback="getError('10 пакетов пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc1-input"
                        name="10 пакетов пересчет"
                        v-validate="priceValidation"
                        data-vv-as="10 пакетов пересчет"
                        class="text-right"
                        v-model="modelPackages[0].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('10 пакетов пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '20 пакетов'"
                      :invalid-feedback="getError('20 пакетов пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc2-input"
                        name="20 пакетов пересчет"
                        v-validate="priceValidation"
                        data-vv-as="20 пакетов пересчет"
                        class="text-right"
                        v-model="modelPackages[1].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('20 пакетов пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '50 пакетов'"
                      :invalid-feedback="getError('50 пакетов пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc3-input"
                        name="50 пакетов пересчет"
                        v-validate="priceValidation"
                        data-vv-as="50 пакетов пересчет"
                        class="text-right"
                        v-model="modelPackages[2].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('50 пакетов пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '100 пакетов'"
                      :invalid-feedback="getError('100 пакетов пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc4-input"
                        name="100 пакетов пересчет"
                        v-validate="priceValidation"
                        data-vv-as="100 пакетов пересчет"
                        class="text-right"
                        v-model="modelPackages[3].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('100 пакетов пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200 пакетов'"
                      :invalid-feedback="getError('200 пакетов пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc5-input"
                        name="200 пакетов пересчет"
                        v-validate="priceValidation"
                        data-vv-as="200 пакетов пересчет"
                        class="text-right"
                        v-model="modelPackages[4].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('200 пакетов пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc6-input"
                        name="200+ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="200+ пересчет"
                        class="text-right"
                        v-model="modelPackages[5].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('200+ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                  <template v-slot:cell(price)="data">
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ цена с превышения')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc7-input"
                        name="200+ цена с превышения"
                        v-validate="priceValidation"
                        data-vv-as="200+ цена с превышения"
                        class="text-right"
                        v-model="modelPackagesMax[0].client_points_cost"
                        :disabled="disabled"
                        :state="validateState('200+ цена с превышения')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                  <template v-slot:cell(priceRecalc)="data">
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ вознаграждение от пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalc8-input"
                        name="200+ вознаграждение от пакетов"
                        v-validate="priceValidation"
                        data-vv-as="200+ вознаграждение от пакетов"
                        class="text-right"
                        v-model="modelPackagesMax[0].daobit_points_cost"
                        :disabled="disabled"
                        :state="validateState('200+ вознаграждение от пакетов')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <h4 class="form-title">Предварительное информирование</h4>
            <b-row>
              <b-col xl="8">
                <b-table
                  id="data_table"
                  hover
                  class="text-center"
                  ref="packagesPI"
                  tbody-tr-class="td-centered"
                  :fields="fields"
                  :items="modelPackagesPI">
                  <template v-slot:cell(packageName)="data">
                    <b>{{ data.item.packageName }}</b>
                  </template>
                  <template v-slot:cell(rangeDefault)="data">
                    <b-form-group
                      v-if="data.item.packageName === '10 пакетов'"
                      :invalid-feedback="getError('10 пакетов ПИ')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefaultPI1-input"
                        name="10 пакетов ПИ"
                        v-validate="priceValidation"
                        data-vv-as="10 пакетов"
                        class="text-right"
                        v-model="modelPackagesPI[0].clientPrice"
                        :disabled="disabled"
                        :state="validateState('10 пакетов ПИ')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '20 пакетов'"
                      :invalid-feedback="getError('20 пакетов ПИ')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefaultPI2-input"
                        name="20 пакетов ПИ"
                        v-validate="priceValidation"
                        data-vv-as="20 пакетов ПИ"
                        class="text-right"
                        v-model="modelPackagesPI[1].clientPrice"
                        :disabled="disabled"
                        :state="validateState('20 пакетов ПИ')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '50 пакетов'"
                      :invalid-feedback="getError('50 пакетов ПИ')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefaultPI3-input"
                        name="50 пакетов ПИ"
                        v-validate="priceValidation"
                        data-vv-as="50 пакетов ПИ"
                        class="text-right"
                        v-model="modelPackagesPI[2].clientPrice"
                        :disabled="disabled"
                        :state="validateState('50 пакетов ПИ')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '100 пакетов'"
                      :invalid-feedback="getError('100 пакетов ПИ')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefaultPI4-input"
                        name="100 пакетов ПИ"
                        v-validate="priceValidation"
                        data-vv-as="100 пакетов ПИ"
                        class="text-right"
                        v-model="modelPackagesPI[3].clientPrice"
                        :disabled="disabled"
                        :state="validateState('100 пакетов ПИ')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200 пакетов'"
                      :invalid-feedback="getError('200 пакетов ПИ')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefaultPI5-input"
                        name="200 пакетов ПИ"
                        v-validate="priceValidation"
                        data-vv-as="200 пакетов ПИ"
                        class="text-right"
                        v-model="modelPackagesPI[4].clientPrice"
                        :disabled="disabled"
                        :state="validateState('200 пакетов ПИ')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ ПИ')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeDefaultPI6-input"
                        name="200+ ПИ"
                        v-validate="priceValidation"
                        data-vv-as="200+ ПИ"
                        class="text-right"
                        v-model="modelPackagesPI[5].clientPrice"
                        :disabled="disabled"
                        :state="validateState('200+ ПИ')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                  <template v-slot:cell(rangeRecalc)="data">
                    <b-form-group
                      v-if="data.item.packageName === '10 пакетов'"
                      :invalid-feedback="getError('10 пакетов ПИ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI1-input"
                        name="10 пакетов ПИ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="10 пакетов ПИ пересчет"
                        class="text-right"
                        v-model="modelPackagesPI[0].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('10 пакетов ПИ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '20 пакетов'"
                      :invalid-feedback="getError('20 пакетов ПИ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI2-input"
                        name="20 пакетов ПИ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="20 пакетов ПИ пересчет"
                        class="text-right"
                        v-model="modelPackagesPI[1].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('20 пакетов ПИ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '50 пакетов'"
                      :invalid-feedback="getError('50 пакетов ПИ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI3-input"
                        name="50 пакетов ПИ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="50 пакетов ПИ пересчет"
                        class="text-right"
                        v-model="modelPackagesPI[2].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('50 пакетов ПИ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '100 пакетов'"
                      :invalid-feedback="getError('100 пакетов ПИ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI4-input"
                        name="100 пакетов ПИ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="100 пакетов ПИ пересчет"
                        class="text-right"
                        v-model="modelPackagesPI[3].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('100 пакетов ПИ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200 пакетов'"
                      :invalid-feedback="getError('200 пакетов ПИ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI5-input"
                        name="200 пакетов ПИ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="200 пакетов ПИ пересчет"
                        class="text-right"
                        v-model="modelPackagesPI[4].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('200 пакетов ПИ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ ПИ пересчет')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI6-input"
                        name="200+ ПИ пересчет"
                        v-validate="priceValidation"
                        data-vv-as="200+ ПИ пересчет"
                        class="text-right"
                        v-model="modelPackagesPI[5].recalcPrice"
                        :disabled="disabled"
                        :state="validateState('200+ ПИ пересчет')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                  <template v-slot:cell(price)="data">
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ ПИ цена с превышения')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI7-input"
                        name="200+ ПИ цена с превышения"
                        v-validate="priceValidation"
                        data-vv-as="200+ ПИ цена с превышения"
                        class="text-right"
                        v-model="modelPackagesPIMax[0].client_points_cost"
                        :disabled="disabled"
                        :state="validateState('200+ ПИ цена с превышения')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                  <template v-slot:cell(priceRecalc)="data">
                    <b-form-group
                      v-if="data.item.packageName === '200+'"
                      :invalid-feedback="getError('200+ ПИ вознаграждение от пакетов')"
                      style="margin-bottom: 0">
                      <b-form-input
                        id="rangeRecalcPI8-input"
                        name="200+ ПИ вознаграждение от пакетов"
                        v-validate="priceValidation"
                        data-vv-as="200+ ПИ вознаграждение от пакетов"
                        class="text-right"
                        v-model="modelPackagesPIMax[0].daobit_points_cost"
                        :disabled="disabled"
                        :state="validateState('200+ ПИ вознаграждение от пакетов')"
                      ></b-form-input>
                    </b-form-group>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <h4 class="form-title">Дополнительная учетная запись</h4>
            <b-row>
            <b-col xl="4">
              <b-table
                id="data_table"
                ref="compensation"
                tbody-tr-class="td-centered"
                :fields="accountFields"
                :items="accountsModel">
                <template v-slot:cell(clientPrice)="">
                  <b-form-group
                    :invalid-feedback="getError('Доп. уч. запись')"
                    style="margin-bottom: 0">
                      <b-form-input
                        id="clientPrice-input"
                        name="Доп. уч. запись"
                        v-validate="priceValidation"
                        data-vv-as="Доп. уч. запись"
                        v-model="accountsModel[0].clientPrice"
                        class="text-right"
                        :disabled="disabled"
                        :state="validateState('Доп. уч. запись')">
                      </b-form-input>
                 </b-form-group>
                </template>
                <template v-slot:cell(recalcPrice)="">
                  <b-form-group
                    :invalid-feedback="getError('Доп. уч. запись пересчет')"
                    style="margin-bottom: 0">
                      <b-form-input
                        id="recalcPrice-input"
                        name="Доп. уч. запись пересчет"
                        v-validate="priceValidation"
                        data-vv-as="Доп. уч. запись пересчет"
                        v-model="accountsModel[0].recalcPrice"
                        class="text-right"
                        :disabled="disabled"
                        :state="validateState('Доп. уч. запись пересчет')">
                      </b-form-input>
                 </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <h4 class="form-title">Вознаграждение</h4>
          <b-row>
            <b-col xl="4">
              <b-table
                id="data_table"
                ref="compensation"
                tbody-tr-class="td-centered"
                :fields="compensationFields"
                :items="compensationModel">
                <template v-slot:cell(type)="data">
                  <b>{{ data.item.type }}</b>
                </template>
                <template v-slot:cell(percent)="data">
                  <b-form-group
                    v-if="data.item.type === 'Тариф'"
                    :invalid-feedback="getError('Тариф')"
                    style="margin-bottom: 0">
                    <div class="d-flex">
                      <b-form-input
                        id="percentLicense-input"
                        name="Тариф"
                        v-validate="priceValidation"
                        data-vv-as="Тариф"
                        v-model="compensationModel.percentLicense"
                        class="text-right"
                        :disabled="disabled"
                        :state="validateState('Тариф')">
                      </b-form-input>
                    <b-button :disabled="disabled" @click="recalcPrices" variant="outline-primary" v-b-tooltip title="Рассчитать" class="ml-4"><i class="fas fa-calculator"></i></b-button>
                   </div>
                 </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-3">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false) || disabled"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить прайс</span>
                  <span v-else>Изменить прайс</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import moment from 'moment'

export default {
  name: 'AddPskovPrice',
  components: {
  },
  props: ['addPrice', 'startMonth', 'startYear', 'disabled'],
  mixins: [validation],
  data () {
    return {
      billingAlias: 'dyn_disc_multi',
      sidebarWidth: '',
      priceData: null,
      items: [],
      dateStart: null,
      fields: [
        { key: 'packageName', label: 'Наименование тарифа' },
        { key: 'range', label: 'Количество пакетов' },
        { key: 'rangeDefault', label: 'Стоимость' },
        { key: 'rangeRecalc', label: 'Вознаграждение' },
        { key: 'price', label: 'Цена с превышения' },
        { key: 'priceRecalc', label: 'Вознаграждение от пакетов' }
      ],
      modelPackages: [
        { pricePosition: 'tpp_multi_packages_10', section: 'mps_common', packageName: '10 пакетов', range: '1-10', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_packages_20', section: 'mps_common', packageName: '20 пакетов', range: '11-20', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_packages_50', section: 'mps_common', packageName: '50 пакетов', range: '21-50', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_packages_100', section: 'mps_common', packageName: '100 пакетов', range: '51-100', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_packages_200', section: 'mps_common', packageName: '200 пакетов', range: '101-200', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_packages_maximum', section: 'mps_common', packageName: '200+', range: '200+', clientPrice: null, recalcPrice: null }
      ],
      modelPackagesPI: [
        { pricePosition: 'tpp_multi_pi_packages_10', section: 'mps_pi', packageName: '10 пакетов', range: '1-10', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_pi_packages_20', section: 'mps_pi', packageName: '20 пакетов', range: '11-20', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_pi_packages_50', section: 'mps_pi', packageName: '50 пакетов', range: '21-50', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_pi_packages_100', section: 'mps_pi', packageName: '100 пакетов', range: '51-100', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_pi_packages_200', section: 'mps_pi', packageName: '200 пакетов', range: '101-200', clientPrice: null, recalcPrice: null },
        { pricePosition: 'tpp_multi_pi_packages_maximum', section: 'mps_pi', packageName: '200+', range: '200+', clientPrice: null, recalcPrice: null }
      ],
      modelPackagesMax: [
        { message_price_position_alias: 'mps_common', client_points_cost: null, daobit_points_cost: null }
      ],
      modelPackagesPIMax: [
        { message_price_position_alias: 'mps_pi', client_points_cost: null, daobit_points_cost: null }
      ],
      compensationModel: [
        { type: 'Тариф', percentLicense: null }
      ],
      accountFields: [
        { key: 'clientPrice', label: 'Стоимость' },
        { key: 'recalcPrice', label: 'Вознаграждение' }
      ],
      accountsModel: [
        { clientPrice: null, recalcPrice: null }
      ],
      compensationFields: [
        { key: 'type', label: 'Тип' },
        { key: 'percent', label: 'Процент' }
      ],
      freezeModelPackages: null,
      freezeModelPackagesPI: null,
      freezeModelPackagesMax: null,
      freezeModelPackagesPIMax: null
    }
  },
  watch: {
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData
      }
    )
  },
  mounted () {
    this.calcSidebarWidth()
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '50%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.modelPackages.map((item) => {
        item.recalcPrice = item.clientPrice && this.compensationModel.percentLicense ? parseFloat(this.percentage(this.compensationModel.percentLicense, item.clientPrice)) : null
      })
      this.modelPackagesPI.map((item) => {
        item.recalcPrice = item.clientPrice && this.compensationModel.percentLicense ? parseFloat(this.percentage(this.compensationModel.percentLicense, item.clientPrice)) : null
      })
      this.accountsModel[0].recalcPrice = this.accountsModel[0].clientPrice && this.compensationModel.percentLicense ? parseFloat(this.percentage(this.compensationModel.percentLicense, this.accountsModel[0].clientPrice)) : null
      this.modelPackagesMax[0].daobit_points_cost = this.modelPackagesMax[0].client_points_cost && this.compensationModel.percentLicense ? parseFloat(this.percentage(this.compensationModel.percentLicense, this.modelPackagesMax[0].client_points_cost)) : null
      this.modelPackagesPIMax[0].daobit_points_cost = this.modelPackagesPIMax[0].client_points_cost && this.compensationModel.percentLicense ? parseFloat(this.percentage(this.compensationModel.percentLicense, this.modelPackagesPIMax[0].client_points_cost)) : null
    },
    getData () {
      this.freezeModelPackages = JSON.parse(JSON.stringify(this.modelPackages))
      this.freezeModelPackagesPI = JSON.parse(JSON.stringify(this.modelPackagesPI))
      this.freezeModelPackagesMax = JSON.parse(JSON.stringify(this.modelPackagesMax))
      this.freezeModelPackagesPIMax = JSON.parse(JSON.stringify(this.modelPackagesPIMax))
      this.freezeAccountsModel = JSON.parse(JSON.stringify(this.accountsModel))
      if (!this.addPrice) {
        this.getDealerPrice({ month: this.startMonth, year: this.startYear, id: this.$route.params.id, billing_alias: this.billingAlias }).then(
          () => {
            const dt = this.startYear + '-' + (this.startMonth.length > 0 ? this.startMonth : ('0' + this.startMonth)) + '-' + '01'
            this.dateStart = moment(dt)
            this.dealerPriceData.lycense.map((item) => {
              const modelItem = this.modelPackages.find(x => x.pricePosition === item.price_position)
              if (modelItem) {
                modelItem.clientPrice = item.client_price
                modelItem.recalcPrice = item.daobit_price
              }
              const modelPIitem = this.modelPackagesPI.find(x => x.pricePosition === item.price_position)
              if (modelPIitem) {
                modelPIitem.clientPrice = item.client_price
                modelPIitem.recalcPrice = item.daobit_price
              }
            })
            this.dealerPriceData.packages.map((item) => {
              if (item.message_price_position_alias === 'mps_common') {
                this.modelPackagesMax[0].client_points_cost = item.client_points_cost
                this.modelPackagesMax[0].daobit_points_cost = item.daobit_points_cost
              }
              if (item.message_price_position_alias === 'mps_pi') {
                this.modelPackagesPIMax[0].client_points_cost = item.client_points_cost
                this.modelPackagesPIMax[0].daobit_points_cost = item.daobit_points_cost
              }
            })
            this.accountsModel[0].clientPrice = this.dealerPriceData.accounts.client_price
            this.accountsModel[0].recalcPrice = this.dealerPriceData.accounts.daobit_price
            this.calcCompensationPercent()
          }
        )
      } else {
        this.dateStart = null
      }
    },
    async saveFormData () {
      const modelPackagesArr = this.modelPackages.map((item) => {
        return {
          price_position: item.pricePosition,
          section: item.section,
          client_price: item.clientPrice ? parseFloat(item.clientPrice) : 0,
          daobit_price: item.recalcPrice ? parseFloat(item.recalcPrice) : 0
        }
      })
      const modelPackagesPIArr = this.modelPackagesPI.map((item) => {
        return {
          price_position: item.pricePosition,
          section: item.section,
          client_price: item.clientPrice ? parseFloat(item.clientPrice) : 0,
          daobit_price: item.recalcPrice ? parseFloat(item.recalcPrice) : 0
        }
      })
      const data = {
        year: this.addPrice ? this.dateStart.toDate().getFullYear() : this.startYear,
        month: this.addPrice ? this.dateStart.toDate().getMonth() + 1 : this.startMonth,
        year_new: this.dateStart.toDate().getFullYear(),
        month_new: this.dateStart.toDate().getMonth() + 1,
        lycense: modelPackagesArr.concat(modelPackagesPIArr),
        packages: this.modelPackagesMax.concat(this.modelPackagesPIMax),
        accounts: {
          client_price: this.accountsModel[0].clientPrice ? parseFloat(this.accountsModel[0].clientPrice) : 0,
          daobit_price: this.accountsModel[0].recalcPrice ? parseFloat(this.accountsModel[0].recalcPrice) : 0
        }
      }
      if (this.addPrice) {
        this.saveDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          () => {
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.pskovPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerPrice({ data: data, billing_alias: this.billingAlias, id: this.$route.params.id }).then(
          () => {
            this.getDealerPricesData({ id: this.$route.params.id })
            this.$refs.pskovPriceSidebar.hide()
          }
        )
      }
    },
    calcCompensationPercent () {
      const percents = []
      this.dealerPriceData.lycense.map((item) => {
        percents.push(parseFloat((item.daobit_price * 100 / item.client_price).toFixed(2)))
        percents.push(parseFloat((item.daobit_additional_account_price * 100 / item.client_additional_account_price).toFixed(2)))
      })
      this.dealerPriceData.packages.map((item) => {
        percents.push(parseFloat((item.daobit_points_cost * 100 / item.client_points_cost).toFixed(2)))
      })
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.compensationModel.percentLicense = Object.keys(counts)[0]
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
      setTimeout(() => {
        this.dateStart = null
        this.modelPackages = this.freezeModelPackages
        this.modelPackagesPI = this.freezeModelPackagesPI
        this.modelPackagesMax = this.freezeModelPackagesMax
        this.modelPackagesPIMax = this.freezeModelPackagesPIMax
        this.accountsModel = this.freezeAccountsModel
        this.compensationModel.percentLicense = null
        this.setPrice(null)
      }, 200)
    },
    ...mapActions('dealers', [
      'saveDealerPrice',
      'getDealerPricesData',
      'updateDealerPrice',
      'getDealerPrice'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>

<style scoped>
  h2 {
    margin-bottom: 20px;
    margin-top: 10px;
    color: #37474F;
    font-size: 25px;
    font-weight: 500;
    line-height: 28px;
  }
  .form-control.is-valid {
    padding: 0.375rem 0.75rem !important;
  }
  .form-control.is-invalid {
    padding: 0.375rem 0.75rem !important;
  }
</style>
